import LazyLoadedImage from 'launch/components/LazyLoadedImage';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

class ImageTile extends Component {
    renderTitle() {
        const { title } = this.props;
        if (title) {
            return <div className="image-tile__text__title">{title}</div>;
        }
    }

    renderLabel() {
        const { label } = this.props;
        if (label) {
            return <div className="image-tile__text__label">{label}</div>;
        }
    }

    renderText() {
        const label = this.renderLabel();
        const title = this.renderTitle();

        if (label || title) {
            return (
                <div className="image-tile__text">
                    {this.renderTitle()}
                    {this.renderLabel()}
                </div>
            );
        }
    }

    render() {
        const { url } = this.props;

        const classes = classNames('image-tile', {
            'image-tile--spaced': this.props.imagePadding,
            [`image-tile--${this.props.textWidth}-text`]: this.props.textWidth,
            [`image-tile--${this.props.textSize}-text`]: this.props.textSize,
        });

        return (
            <div className={classes}>
                <div className="image-tile__inner">
                    <div className="image-tile__inner__spacing">
                        <div className="image-tile__inner__alignment">
                            <div className="image-tile__image">
                                <LazyLoadedImage url={url} />
                            </div>
                            {this.renderText()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ImageTile.defaultProps = {
    imagePadding: false,
};

ImageTile.propTypes = {
    url: PropTypes.string.isRequired,
    imagePadding: PropTypes.bool,
    textWidth: PropTypes.oneOf(['narrow']),
    textSize: PropTypes.oneOf(['large']),
};

export default ImageTile;
